module.exports = __webpack_public_path__ + "img/HR.51aa7229.svg";